import React, { useState } from "react";
import PropTypes from "prop-types";
import { Menu, MenuItem } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

import UIButton from "../UIButton";
import { clx } from "../../../utils/Helpers";
import "./_UIIconMenu.scss";

const UIIconMenu = ({ items, icon, ariaLabel, className, buttonClassName }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);
  const close = () => setAnchorEl(null);

  if (!items.length) return null;

  return (
    <div className={clx("ui-icon-menu", className)}>
      <UIButton
        type="button"
        size="small"
        variant="outlined"
        color="inherit"
        className={clx("ui-icon-menu__trigger", buttonClassName)}
        aria-label={ariaLabel}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        {icon}
      </UIButton>

      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={close}
        PaperProps={{ className: "ui-icon-menu__paper" }}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        {items.map((item) => (
          <MenuItem
            key={item.key}
            className={clx(
              "ui-icon-menu__item",
              item.tone === "danger" && "ui-icon-menu__item--danger",
            )}
            disabled={item.disabled}
            onClick={() => {
              close();
              item.onClick?.();
            }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

UIIconMenu.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      tone: PropTypes.oneOf(["danger", "neutral"]),
      disabled: PropTypes.bool,
      onClick: PropTypes.func,
    }),
  ).isRequired,
  icon: PropTypes.node,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  buttonClassName: PropTypes.string,
};

UIIconMenu.defaultProps = {
  icon: <EditOutlinedIcon sx={{ fontSize: 18 }} />,
  ariaLabel: "Open menu",
  className: "",
  buttonClassName: "",
};

export default UIIconMenu;
